<template>
  <div>
    <Banner />
    <div class="main-content">
      <div class="model-name">项目概览</div>
      <div class="model-name-en">Project overview</div>
      <div class="text-content mt30" v-html="info.titleContent"></div>
      <!-- <div class="tab-buttons">
        <div class="tab-button" :class="activeTab == index ? 'tab-button-active':''" @click="activeTab = index"
          v-for="(item, index) in tabBtns" :key="index">{{item.text}}</div>
      </div> -->

      <!-- <div class="model-name">项目产业</div>
      <div class="model-name-en">Project industry</div>
      <div class="project-industry-content">
        <Accordion />
      </div> -->
    </div>
  </div>
</template>

<script>
import { loadYxTitle } from "@/api/api";
import Banner from "../../components/Banner";
import Accordion from "@/components/Accordion";
export default {
  components: {
    Banner,
    Accordion,
  },
  data() {
    return {
      activeTab: 0,
      info: {},
      tabBtns: [
        {
          text: "品质化农业",
        },
        {
          text: "传承式文化",
        },
        {
          text: "生态化康养",
        },
        {
          text: "自然性科学",
        },
        {
          text: "专业社交运动",
        },
        {
          text: "智能化旅游",
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      loadYxTitle().then((res) => {
        var data = res.content.find((item) => {
          return item.titleType == 2;
        });
        if (data) {
          this.info = data;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.text-content {
  width: 100%;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  color: #333333;
  overflow-x: hidden;
}
.tab-button {
  margin-right: 24px;
}
.project-industry-content {
  width: 1200px;
  height: 572px;
  margin: 0 auto;
}
.base-info {
  width: 100%;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  color: #333333;
  margin-bottom: 25px;
}
</style>
